import { posts } from '@/content/posts';
import { PostListItem } from '@/components/PostListItem';

export function Blog() {
  return (
    <section className="py-4 md:py-12">
      <h1 className="sr-only">Blog</h1>
      <div>
        {posts.map((post) => (
          <PostListItem key={post.slug} post={post} />
        ))}
      </div>
    </section>
  );
}
